import st from "@/styles/AccountPage.module.scss"
import {useAtom} from "jotai/index";
import {profile} from "@/atoms/profile.ts";
import {CircularProgress} from "@mui/joy";
import {useTranslation} from "react-i18next";



interface Props {

}

const GenInfo:React.FC<Props> = () => {
    
    const [user ] = useAtom(profile)
    const {t} = useTranslation()
    
    if(!user) return (
        <div className={st.gen_info}>
            <CircularProgress color={"success"}/>
        </div>
    )
    
    
    const info = [
        {
            label: t("name_surname"),
            val: `${user.first_name} ${user.last_name}`
        },
        
        {
            label: t("phone"),
            val: `${user.phone}`
        },
        {
            label: t("idnx"),
            val: `${user.idnx}`
        },
        {
            label: t("email"),
            val: `${user.email}`
        },
        
    ]
    
    
    return (
        <div className={st.gen_info}>
            {info.map((inf:any, i:number) => {
                return inf.val.length > 1 ? (
                    <div key={`info_key_${i}`} className={st.inf_item}>
                        <span className={st.label}>
                            {inf.label}
                        </span>
                        
                        <span className={st.val}>
                            {inf.val}
                        </span>
                    </div>
                ) : null
            })}
        </div>
    )
}

export default GenInfo